module.exports = __webpack_public_path__ + "img/left-quote.3a0c3ef6.svg";